import { availableComponents, renderingTools } from '@as-react/as-react';
import type { AemConfiguration } from '@as-react/common-types';
import { Hydrater } from '@as-react/hydrater';
import { Logger } from '@as-react/logger';

import { bootstrap } from './client/bootstrap';
import { activateMediatorSubscribers } from './client/mediator/mediatorSubscriber';
import { initI18nClient } from './modules/i18n/i18n-client';

import './utils/polyfills';

declare const SITE: { Config: AemConfiguration };

const locale = SITE.Config.locale;
const aemVersion = SITE.Config.version || 'latest';
const translationLang = SITE.Config.translationLang;

(async () => {
  await Logger.init({
    release: process.env.REACT_VERSION!,
  });

  const i18n = await initI18nClient({
    aemVersion,
    translationLang,
    locale,
  });

  try {
    activateMediatorSubscribers();
  } catch {}

  if (process.env.LOCAL_TESTING !== 'true') {
    bootstrap();
  }

  await Hydrater({
    availableComponents,
    root: document,
    renderingTools,
    locale,
    translationLang,
    aemVersion,
    i18n,
  });
})();
